<template>
  <div>
    <div class="GenderRadioButtonArea" :class="{ isPc: !isSp }">
      <InputLabel
        class="labelArea"
        :class="{ isPc: !isSp, isHasLabel: !isSp && (required || optional) }"
        :required="required"
      >
        性別
      </InputLabel>
      <div class="GenderRadioButtonArea__form">
        <RadioButton
          v-model="handleSelectValue"
          class="inputItem"
          :class="{ hasError: hasError, isPc: !isSp }"
          :item-list="itemListTop"
          :disabled="disabled"
          :flex-auto-num="2"
          question-id="gender"
          @change="onChange"
        />
        <RadioButton
          v-model="handleSelectValue"
          class="inputItem inputItem--mt8"
          :class="{ hasError: hasError, isPc: !isSp }"
          :item-list="itemListBottom"
          :disabled="disabled"
          question-id="gender"
          @change="onChange"
        />
        <InputItem
          v-model="handleInputValue"
          class="inputItem inputItem__textForm"
          input-type="text"
          :class="{ hasInputError: hasInputError, isPc: !isSp }"
          :disabled="isTextAreaDisabled"
          :maxlength="'40'"
          @change="inputValue"
          @blur="onBlur"
          @focus="onFocusGender"
        />
        <p class="GenderRadioButtonArea__form__message">最大40文字まで</p>
      </div>
    </div>
    <div class="underInputArea" :class="{ isPc: !isSp }">
      <PartialErrorMessage :is-sp-flg="true" :error="errorFromOuterExpression" class="partialErrorComponent" />
    </div>
    <p class="underInputAreaMessage" :class="{ isPc: !isSp }">
      自由記載の内容は、プロフィール画面で閲覧可能です。保護者や学校関係者への公開はありません。
    </p>
    <div class="underInputArea" :class="{ isPc: !isSp }">
      <PartialErrorMessage :is-sp-flg="true" :error="errorFromOuter" class="partialErrorComponent" />
    </div>
  </div>
</template>

<script>
import InputLabel from '../Text/InputLabel.vue';
import RadioButton from './RadioButton.vue';
import PartialErrorMessage from '../PartialErrorMessage.vue';
import InputItem from './InputItem.vue';
import { checkWordCount, isEmpty, checkGenderCharCode } from '../../../../helper/_validationCheck';
import { generateWordCountError } from '../../../../helper/_validationCheckMessages';

/**
 * 性別選択ラジオボタンコンポーネント
 * 一括で選択肢を増やす可能性があるのでコンポーネント化しておく
 */
export default {
  name: 'GenderRadioButtonArea',
  components: {
    InputLabel,
    RadioButton,
    PartialErrorMessage,
    InputItem,
  },
  model: {
    prop: 'selectGender',
    event: 'change',
  },
  props: {
    selectGender: {
      type: String,
      required: true,
    },
    genderExpression: {
      type: String,
      required: false,
    },
    validateAtMount: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * 外部からのエラー
     * このコンポーネント自体はエラーを発出しない。
     * が、『未選択エラー』を外部から入れ込むケースがある。
     */
    errorFromOuter: {
      type: String,
      required: false,
      default: '',
    },
    errorFromOuterExpression: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    uneditableFlag: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      inputValueText: '',
      validationErrorGender: '',
      errorMessage: '',
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    itemListTop() {
      return [
        {
          text: '男性',
          value: '1',
        },
        {
          text: '女性',
          value: '2',
        },
        {
          text: '回答しない',
          value: '3',
        },
      ];
    },
    itemListBottom() {
      return [
        {
          text: '自由記載',
          value: '4',
        },
      ];
    },
    isTextAreaDisabled() {
      return ['', '0', '1', '2', '3'].includes(this.selectGender) || this.uneditableFlag === true;
    },
    hasError() {
      // errorFromOuterがfalsyならエラーない
      if (!this.errorFromOuter && !this.errorFromOuterExpression) return false;
      // errorFromOuterがlengthもってるならエラーあり
      if (this.errorFromOuter.length || this.errorFromOuterExpression.length) return true;
      return false;
    },
    hasInputError() {
      if (!this.isTextAreaDisabled) {
        if (!this.errorFromOuter && !this.errorFromOuterExpression) return false;
        // errorFromOuterがlengthもってるならエラーあり
        if (this.errorFromOuter.length || this.errorFromOuterExpression.length) return true;
        return false;
      }
      return false;
    },
    handleSelectValue: {
      get() {
        return this.selectGender;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    handleInputValue: {
      get() {
        return this.genderExpression;
      },
      set(value) {
        this.$emit('changeInputValue', value);
      },
    },
  },
  watch: {
    selectGender: {
      handler: 'handleGenderChange',
      immediate: true,
    },
  },
  methods: {
    handleGenderChange() {
      if (this.validateAtMount && this.selectGender === '4' && this.genderExpression) {
        this.inputValueText = this.genderExpression;
        this.onBlur();
      }
    },
    onChange(value) {
      this.errorMessage = '';
      this.inputValueText = '';
      if (value !== '4') {
        this.inputValueText = '';
        this.$emit('inputText', this.inputValueText);
      }
      this.$emit('watchValidation');
      // 自由記載のエラーを消す
      this.$emit('watchInputTextValidation', this.errorMessage);
    },
    onFocusGender() {
      this.$emit('focusGender');
    },
    async onBlur() {
      // blurイベントがchangeイベントより先に発火するため、blurを遅延させた
      setTimeout(async () => {
        await this.validationCheck(this.inputValueText);
        if (!this.validationErrorGender) {
          this.$emit('inputText', this.inputValueText);
        }
      }, 100);
    },
    async validationCheck(value) {
      // 編集不可の場合はバリデーションを行わない
      if (this.uneditableFlag) return;
      this.errorMessage = '';
      const min = '1';
      const max = '40';
      // 自由記載以外の場合、空であってもエラー文言は返さない
      if (this.isTextAreaDisabled) return;
      // 空チェック
      if (isEmpty(value)) {
        this.errorMessage = '自由記載の入力がありません。';
      } else if (value && !checkWordCount(value, min, max)) {
        // 文字数チェック
        this.errorMessage = generateWordCountError('自由記載', undefined, max);
      } else {
        // 入力内容のチェック
        const responseData = await this.errorCheckGenderCharCode(value);
        if (responseData) {
          this.errorMessage = `自由記載に使用できない文字が含まれています。使用できない文字列は{${responseData}}です。`;
        } else {
          this.errorMessage = '';
        }
      }
      this.$emit('watchInputTextValidation', this.errorMessage);
    },
    async errorCheckGenderCharCode(value) {
      try {
        const checkCharCode = await checkGenderCharCode(value);
        if (checkCharCode.resultCode === 0) {
          return null;
        }
        if (checkCharCode.resultCode === 1) {
          return checkCharCode.errorChar;
        }
        throw Error;
      } catch (error) {
        // DBエラーなどは何もしないで確認済み
        return null;
      }
    },
    inputValue(value) {
      this.inputValueText = value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.GenderRadioButtonArea {
  .labelArea.isPc {
    width: 120px;
    margin-top: 14px;

    &.isHasLabel {
      width: 184px;
    }
  }

  .inputItem--mt8 {
    margin-top: 8px;
  }

  .inputItem.isPc {
    width: 432px;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1;
  }

  &.isPc {
    display: flex;
  }

  .inputItem__textForm {
    margin-top: 8px;
  }
}

.GenderRadioButtonArea__form__message {
  margin-top: 8px;
  text-align: right;
  color: #808d96;
  font-size: 10px;
  font-weight: 300;
  line-height: 1.5;
}

.underInputArea.isPc {
  margin-left: 184px;
}

.underInputAreaMessage {
  margin-top: 8px;
  color: #808d96;
  font-size: 12px;
  font-weight: 300;
  line-height: 1.5;
}

.underInputAreaMessage.isPc {
  margin-left: 184px;
}

.partialErrorComponent {
  margin-top: 8px;
}

.hasInputError,
.hasInputError:focus {
  border: $border-alert;
}
</style>
